import React, { useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Modal } from "../../common/Modal/Modal";
import { Button } from "../../common/Button/Button";
import { COLORS } from "../../../assets/constants/styles";
import { TestConversationMessages } from "../../Test/TestConversationMessages/TestConversationMessages";

export const AddChatModal = ({ isOpen, onClose, onSave }) => {
  const { t } = useTranslation();
  const [messages, setMessages] = useState([]);

  const resetForm = () => {
    setMessages([]);
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const handleSave = () => {
    onSave({
      messages,
    });

    resetForm();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose}>
      <ModalContent>
        <ModalHeader>
          <ModalTitle>{t("test.addNewChat")}</ModalTitle>
        </ModalHeader>

        <FormContent>
          <MessagesContainer>
            <TestConversationMessages
              conversationData={messages}
              setConversationData={setMessages}
              t={t}
            />
          </MessagesContainer>
        </FormContent>

        <ModalFooter>
          <Button
            text={t("common.cancel")}
            onClick={handleClose}
            variant="white"
          />
          <Button
            text={t("common.save")}
            onClick={handleSave}
            variant="violet"
            disabled={messages.length === 0}
          />
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 550px;
`;

const ModalHeader = styled.div`
  margin-bottom: 1.5rem;
`;

const ModalTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  color: ${COLORS.black};
  margin: 0;
`;

const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1.5rem;
`;

const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const MessagesContainer = styled.div``;
